import { Container, Row, Col, Button, Image } from 'react-bootstrap';


export default function SectionHero() {
  return (
    <>
      <section id="home" className="hero hero-section-image d-flex align-items-start flex-column position-relative">
        <Container className="flex-grow-1 d-flex align-items-center">
          <Row className="align-items-center">
            <Col md={10}>
              <h1 className="display-4 fw-bold text-bpp-green" data-aos="fade-left">Welcome to Biopartitioning and Purification Conference 2026</h1>
              <p className="lead mb-4 h3 text-light" data-aos="fade-left" data-aos-delay="250">
                Join us from 6 to 9 September 2026 in the picturesque town of Bled, Slovenia.
              </p>
              <Button variant="bpp-pink" size="lg" className="text-white d-none">
                <i className="bi bi-chevron-right me-1"></i>
                Get Notified
              </Button>
            </Col>
          </Row>
        </Container>
        <Image src="bpp-02.svg" className="hero-art" />
      </section>
    </>
  );
}